import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteCustomer, ApiGetCustomer, ApiGetCustomerList, ApiInsertCustomer, ApiUpdateCustomer } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function CustomerService() {
    const { showFail } = useModal()

    const { fetch: apiGetCustomerList } = useFetch(ApiGetCustomerList)
    const { fetch: apiGetCustomerById } = useFetch(ApiGetCustomer)
    const { fetch: apiDeleteCustomer } = useFetch(ApiDeleteCustomer)
    const { fetch: apiCreateCustomer } = useFetch(ApiInsertCustomer)
    const { fetch: apiUpdateCustomer } = useFetch(ApiUpdateCustomer)
 
    const fetchCustomerList = async(customerName, address, phone, status, pageSize, pageIndex) => {
        const res =  await apiGetCustomerList({
            data: {
                customerName,
                address, 
                phone,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteCustomer = async(customerId, status) => {
        const res = await apiDeleteCustomer({
            data: {
                customerId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerById = async (customerId) => {
        const res = await apiGetCustomerById({
            data: {
                customerId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateCustomer = async (customerName, address, phone, idPhoto, masterMdrGestun, masterMdrPl, masterMdrPlQris) => {
        let data = new FormData()

        data.append('CustomerName', customerName)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('IdPhoto', idPhoto)
        data.append('MasterMdrGestun', masterMdrGestun)
        data.append('MasterMdrPl', masterMdrPl)
        data.append('MasterMdrPlQris', masterMdrPlQris)

        const res = await apiCreateCustomer({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateCustomer = async (customerId, customerName,address, phone, idPhoto, masterMdrGestun, masterMdrPl, masterMdrPlQris) => {
        let data = new FormData()

        data.append('CustomerId', customerId)
        data.append('CustomerName', customerName)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('IdPhoto', idPhoto)
        data.append('MasterMdrGestun', masterMdrGestun)
        data.append('MasterMdrPl', masterMdrPl)
        data.append('MasterMdrPlQris', masterMdrPlQris)

        const res = await apiUpdateCustomer({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCustomerList,
        fetchCustomerById,
        fetchDeleteCustomer,
        fetchCreateCustomer,
        fetchUpdateCustomer
    }
}